class SendFromAddress {
    id: number;
    emailServerID: number;

    name: string;
    address: string;
    default: boolean;
    global: boolean;
    recycleFlag: boolean;

    tested?: boolean;
    errorMessage: string;

    createdBy: number;
    createdOn: Date;
    editedBy: number;
    editedOn: Date;
    recycledBy: number;
    recycledOn: Date;

    constructor(data: Partial<SendFromAddress>) {
        Object.assign(this, data);
    }
}

export default SendFromAddress;